export default "__VITE_ASSET__CYebfZZf__"